import { camelCase } from 'lodash'
import type { Dispatch, SetStateAction } from 'react'

export const handleTabChange = (
  event: React.SyntheticEvent,
  setSearchParams: Dispatch<SetStateAction<URLSearchParams>>
) => {
  setSearchParams(searchParams => {
    searchParams.set(
      'tab',
      camelCase(event.currentTarget.textContent ?? undefined)
    )
    return searchParams
  })
}
